import { useState, useEffect } from 'react';
import useApi from 'hooks/useApi';
import { ELocalStorageKeys } from 'constants/enums';
import { webStorageUtil } from 'state/webStorage.state.service';

export const useOffers = () => {
  const API = useApi({});
  const [hasNoOffers, setHasNoOffers] = useState<boolean>(false);
  const offers = API.getOffers.data?.offers || {};

  useEffect(() => {
    setHasNoOffers(
      API.getOffers.data &&
        webStorageUtil.get(ELocalStorageKeys.SESSION_TOKEN) &&
        (offers.bundles?.length ?? 0) === 0 &&
        (offers.promotions?.length ?? 0) === 0 &&
        (offers.rolling?.length ?? 0) === 0
    );
  }, [API.getOffers.data]);

  return {
    hasNoOffers,
  };
};
